export const dateCompare = ({
  validFrom,
  validTo,
  testDate,
}: {
  validFrom?: string | null;
  validTo?: string | null;
  testDate?: string | null;
}): boolean => {
  let isInRange: boolean;
  let currentDate: Date = new Date();
  if (testDate && !Number.isNaN(Date.parse(testDate))) {
    currentDate = new Date(testDate);
  }
  const compareVal = currentDate.getTime();

  // valid from - if there is no from date use the current-date (maybe test-date) to be every time valid
  const validFromVal: Date = validFrom ? new Date(validFrom) : currentDate;
  const validFromCompare = validFromVal.getTime();

  isInRange = validFromCompare <= compareVal;

  // valid to
  if (validTo) {
    const validToVal: Date = new Date(validTo);
    const validToCompare = validToVal.getTime();

    isInRange =
      (validFromCompare < compareVal && validToCompare >= compareVal) ||
      (!validFrom && compareVal <= validToCompare);
  }
  return isInRange;
};
